import React, { useEffect, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import LocalisedMessage from 'components/Common/LocalisedMessage';

import { addOnlineForm, addFormGroup } from 'actions';

const FormResult = ({ formType, formGroup, title, accountId }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const availableFormTypes = useSelector(state => state.app?.onlineConfig?.formTypes);

  const isFormSupported = (type) => {
    const form = availableFormTypes.find(f => f.formType === type);
    return (form?.isEnabled === true && form?.isVisible === true);
  };

  const isSupported = useMemo(() => {
    if (!availableFormTypes) {
      return false;
    }
    if (formType) {
      return isFormSupported(formType);
    }
    if (formGroup?.formTypes) {
      let formGroupSupported = true;
      formGroup.formTypes.forEach((ft) => { formGroupSupported = formGroupSupported && isFormSupported(ft); });
      return formGroupSupported;
    }
    return false;
  });

  const openNewForm = () => {
    if (formType) {
      const formTypeInfo = availableFormTypes?.find(ft => ft.formType === formType.toLowerCase());
      dispatch(addOnlineForm(formTypeInfo, accountId));
    } else if (formGroup) {
      dispatch(addFormGroup(formGroup.formTypes, accountId, formGroup.key));
    } else {
      console.log('error: missing formType or formGroup');
    }
  };

  useEffect(() => {
    const lastCard = document.getElementById('formResult');
    if (window && lastCard && lastCard.offsetTop) {
      window.scrollTo({ top: lastCard.offsetTop - 100 });
    }
  }, []);

  return (<React.Fragment>
    { isSupported && <div id="formResult" className="question-card-wrapper matched-form">
      <p className="question-title"><strong><LocalisedMessage id="preQualifyingQuestionnaire.matchedForm.title" /></strong></p>
      <p><LocalisedMessage id="preQualifyingQuestionnaire.matchedForm.mainText" /></p>
      <button className="btn questionnaire-button continue" type="button" onClick={ openNewForm }>{ intl.formatMessage({ id: 'preQualifyingQuestionnaire.ButtonText.Continue' }) }</button>
    </div> }
    { !isSupported && <div id="unSupportedForm" className="question-card-wrapper error unsupported-form">
      <p className="question-title"><strong><LocalisedMessage id="incorrectForm.title" values={ { FormType: `${ title || '' }` } } /></strong></p>
      <p><LocalisedMessage id="incorrectForm.text" /></p>
      <Link to="/form-selection" className="btn btn-link"><LocalisedMessage id="incorrectForm.showAvailableForms" /></Link>
    </div> }
  </React.Fragment>);
};

FormResult.propTypes = {
  formType: PropTypes.string,
  formGroup: PropTypes.shape({
    key: PropTypes.string,
    formTypes: PropTypes.arrayOf(PropTypes.string)
  }),
  title: PropTypes.string,
  accountId: PropTypes.number.isRequired,
};

FormResult.defaultProps = {
  formType: null,
  formGroup: null,
  title: ''
};

export default FormResult;
